<template>
  <main-container>
    <main-header />

    <indicador-navegacao />

    <form-container>
      <form-input-grupo tituloGrupo="Modo De Implantação">
        <form-input-individual>
          <label class="form-pergunta-titulo">Modelo de negócio *</label>
          <span class="form-pergunta-subtitulo">Escolha a opção que melhor se encaixa com a sua empresa.</span>
          <div id="tipoImplantacao">
            <div class="custom-control custom-radio" v-for="implantacao in implantacoes" :key="implantacao.Id">
              <input class="custom-control-input" type="radio" :id="implantacao.Descricao" :value="implantacao" v-model="tipoImplantacao" />
              <label class="custom-control-label" :for="implantacao.Descricao">{{ implantacao.Descricao }}</label>
            </div>
          </div>
        </form-input-individual>
      </form-input-grupo>

      <form-buttons
        @voltar-form-anterior="voltarFormAnterior()"
        @avancar-proximo-form="avancarProximoForm(objetoValidacao, montaObjetoCommit, 'commit', 'setDataEmpresaPT4P1', rotaConformetipoImplantacao)"
      />
    </form-container>
  </main-container>
</template>

<script>
import TIPO_IMPLANTACAO_ENUM from '../../utils/enums/tipo-implantacao';

export default {
  data() {
    return {
      tipoImplantacao: '',
      implantacoes: [],
    };
  },
  computed: {
    rotaConformetipoImplantacao() {
      if (this.tipoImplantacao.Id === TIPO_IMPLANTACAO_ENUM.Franquia) return '/implantacao/franquia';

      // if (this.tipoImplantacao.Id === TIPO_IMPLANTACAO_ENUM.Multimarca) return '/implantacao/multimarca';

      if (this.tipoImplantacao.Id === TIPO_IMPLANTACAO_ENUM.MarcaPropria) return '/portal';

      return '/implantacao';
    },
    objetoValidacao() {
      const dados = [];
      dados.push(this.montaObjetoValidacao(['campoObrigatorio'], this.tipoImplantacao, 'tipoImplantacao'));
      return dados;
    },
    montaObjetoCommit() {
      return {
        tipoImplantacao: this.tipoImplantacao,
      };
    },
  },
  methods: {
    inicializaDados() {
      this.tipoImplantacao = this.$store.state.dadosNavegacao.tipoImplantacao;
      this.implantacoes = this.$store.state.dadosFormulario.implantacoes;
    },
  },
  created() {
    this.inicializaDados();
  },
};
</script>

<style></style>
